App.Model.Subscriber = App.BaseModel.extend({
  idAttribute: 'email'
  validation: {
    email: [
      { required: true
      msg: __('cart_email_required')
      },
      { pattern: 'email'
      msg: __('cart_email_invalid') }
    ]
  }
})

App.View.Subscriber = Backbone.View.extend({
  el: '#subscribe'
  events: {
    'click .save': 'save'
    'change input': 'changed'
    'change select': 'changed'
    'change checkbox': viewUpdateModel }
  initialize: ->
    @model = new App.Model.Subscriber {
      email: $('#email').val()
      langs: []
      subjects: [] }
    Backbone.Validation.bind this, {
      valid: validInput
      invalid: invalidInput }
  save: ->
    errors = @model.validate()
    if !errors
      $.post '/newsletter/subscribe', @model.toJSON(), (json) ->
        $('#subscribe').hide()
        $('#result').show()
    return
  changed: viewUpdateModel
})

$ ->
  $.extend App, {
    Model: {}
    View: {} }
  window.selSubject = new TomSelect '#subjects', {
    valueField: 'id'
    labelField: 'text'
    plugins: {
      virtual_scroll: {}
      remove_button: {
        title: __('remove') }
    }
    maxItems: 50
    score: (search) ->
      return (item) ->
        return 1
    firstUrl: (query) ->
      this.data_page = 1
      return '/newsletter/subjects?q=' + query
    load: (query, callback) ->
      url = this.getUrl(query)
      $.get url, (data) ->
        if data.success
          this.data_page++
          if Math.ceil(data.total / 100) <= this.data_page
            this.setNextUrl(query, '/newsletter/subjects?q=' + query + '&page=' + this.data_page)
          callback(data.items)
    render: {
      item: (item, escape) ->
        opt =  '<div>'
        if item.trail.length > 0
          opt += '>'.repeat(item.trail.length)
        opt += escape(item.text) + '</div>'
      option: (item, escape) ->
        opt =  '<div><span class="nsn">' + escape(item.text) + '</span>'
        if item.trail.length > 0
          opt += ' <div class="nst">' + escape(item.trail.join(' > ')) + '</div>'
        opt +=  '</div>'
        return opt
    }
  }

  view = new App.View.Subscriber()

  new TomSelect '#langs', {
    valueField: 'id'
    labelField: 'text'
    score: (search) ->
      return (item) ->
        return 1
  }
  return